import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import {
	lightGray,
	pageTitleSize,
	socotraBlue2,
	socotraBlue2Faded,
} from '../../data/globalStylingVariables';

export const StyledContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px;
`;
export const StyledSection = styled.div`
	padding: 10px;
`;
export const StyledTitle = styled.div`
	font-size: ${pageTitleSize};
	text-transform: capitalize;
`;

export const StyledTitleBolded = styled.div`
	font-size: ${pageTitleSize};
	font-weight: bold;
	text-transform: capitalize;
`;

export const StyledRow = styled.div`
	display: flex;
`;

export const StyledPHField = styled.div`
	flex-grow: 1;
	margin: 10px;

	&.width-12 {
		width: 100%;
	}
	&.width-11 {
		width: 91.66%;
	}
	&.width-10 {
		width: 83.33%;
	}
	&.width-9 {
		width: 75%;
	}
	&.width-8 {
		width: 66.66%;
	}
	&.width-7 {
		width: 58.33%;
	}
	&.width-6 {
		width: 50%;
	}
	&.width-5 {
		width: 41.66%;
	}
	&.width-4 {
		width: 33.33%;
	}
	&.width-3 {
		width: 25%;
	}
	&.width-2 {
		width: 16.66%;
	}
`;

export const StyledWrappedFields = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

export const StyledSectionContainer = styled.div`
	margin-top: 20px;
`;
export const StyledEmptyMessage = styled.div`
	font-size: 15px;
	text-align: center;
	margin-top: 20px;
`;

export const StyledTableActions = styled.div`
	a {
		margin-right: 10px;
		cursor: pointer;
		text-decoration: underline;
		color: ${socotraBlue2};
	}
`;

export const StyledContentPane = styled.div`
	overflow: auto;
	flex-grow: 1;
	background-color: white;
	border-radius: 4px;
	height: 100%;
`;

export const StyledOverviewContainer = styled.div`
	border-radius: 4px;
	border: 1px solid ${socotraBlue2};
	margin-bottom: 8px;
`;

export const StyledOverviewSection = styled.div`
	padding: 10px;
`;

export const StyledOverviewTitle = styled.div`
	padding: 15px;
	font-weight: 500;
	display: flex;
	align-items: center;
`;

export const StyledLabel = styled.div`
	margin-right: 10px;
	width: 100px;
	font-weight: 500;
`;

export const StyledPolicyDetailsRow = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-around;
	flex-direction: row;
	border-radius: 0px 0px 3px 3px;
	background-color: ${socotraBlue2Faded};
	padding: 15px 15px 0;
	&:last-child {
		padding-bottom: 15px;
	}
`;

export const StyledDetail = styled.div`
	display: flex;
	flex-direction: column;
	margin-right: 20px;
`;

export const StyledTitleContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	margin-top: 10px;
`;

export const StyledModalContentContainer = styled.div`
	display: flex;
	justify-content: space-around;
`;

export const TopContainer = styled.div`
	display: flex;
	justify-content: space-between;
	position: sticky;
	top: 0;
	min-height: 50px;
	background-color: #ffffff;
	align-items: center;
	padding: 3px 15px;
	border-bottom: 1px solid ${lightGray};
	z-index: 99;
`;

export const BodyContainer = styled.div`
	display: block;
`;

export const LayoutContainer = styled.div`
	position: relative;
	width: 100%;
	padding: 0 20px 20px 20px;
	box-sizing: border-box;
	overflow: auto;
	max-width: 1200px;
	margin: auto;
`;

export const PaddedDiv = styled.div`
	padding-top: 20px;
`;

export const RedAsterisk = () => (
	<span style={{ color: 'red', textDecoration: 'none' }}>&nbsp;*</span>
);

export const DropdownIndicator = (props: any) => {
	return (
		<components.DropdownIndicator {...props}>
			<ArrowDropDownIcon />
		</components.DropdownIndicator>
	);
};
